import React from "react"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"

export default function RightInfoTabs({ subTab, onChange }: { subTab: "overview" | "gtins"; onChange: (v: "overview" | "gtins") => void }) {
  return (
    <Tabs value={subTab} onValueChange={(v) => onChange(v as any)}>
      <TabsList className="bg-transparent gap-2">
        <TabsTrigger
          value="overview"
          className="px-3 py-1 text-sm rounded-lg border border-transparent data-[state=active]:border-gray-300 data-[state=active]:text-gray-900"
        >
          Overview
        </TabsTrigger>
        <TabsTrigger
          value="gtins"
          className="px-3 py-1 text-sm rounded-lg border border-transparent data-[state=active]:border-gray-300 data-[state=active]:text-gray-900"
        >
          Product Identifiers (GTINs)
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
